<template>
  <div v-bind="$attrs" class="relative selector" v-click-outside="handleClickOutside">
    <Button
      @click="toggleList(!toggle)"
      :border="toggle"
      :selected="toggle"
      :theme
      :color
      :fontColor
      :bold=false
      :capslock=false
      :size
      tabindex="0"
    >
      <div
        class="flex"
        :class="{
            'flex-content-between': showIso,
            'gap-sm': !showIso
          }">
        <span> {{ data?.[selectedItem]?.name}} {{ showIso ?`| ${data?.[selectedItem]?.iso?.split('-')[0].toLowerCase()}` : '' }} </span>
        <Icons :icon="toggle ? IconsModel.up : IconsModel.down" :color="iconColor" :theme="Theme.none" v-if="data?.length > 1"/>
      </div>
    </Button>
    <div class="list-ctn width-100 flex flex-col" :class="color" v-if="toggle" >
      <template v-for="(item, index) in data">
        <Button
          @click="selectItem(index, data[index].iso)"
          :theme
          :color
          :fontColor
          :bold=false
          :border=false
          :size
          :borderRadius=false
          :capslock=false
          :selected="false"
          :tabindex="index + 1"
           v-if="index !== selectedItem"
        >

          <div
            class="flex"
            :class="{
              'flex-content-between': showIso
            }"
          >
            <span> {{ item?.name  }} {{ showIso ?`| ${data?.[index]?.iso?.split('-')[0].toLowerCase()}` : '' }} </span>
            <Icons :theme="Theme.none" :color="Color.transparent"/>
          </div>
        </Button>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Button, Icons } from '../../atoms'
import { IconsModel, type TypeColor, Color, Theme, type TypeTheme, Size, type TypeSize } from '../../interfaces'
import { watch } from 'vue';
const emit = defineEmits(['update:model'])
const toggle = ref<boolean>(false)
const selectedItem = ref<number>(0)
const model = defineModel({
  type: String,
})

 const props = withDefaults(defineProps<{
  color?: TypeColor,
  iconColor?: TypeColor
  fontColor?: TypeColor
  data?: Array<{iso: string, name: string}>
  theme?: TypeTheme
  showIso?: boolean
  size?: TypeSize,
  close?: boolean
}>(), {
  color: Color.white,
  iconColor: Color.sun,
  fontColor: Color.black,
  theme: Theme.primary,
  size: Size.xl,
  showIso: true,
  close: false,
  data: () => [{ name: 'International', iso: 'en-INT' }],
})
const toggleList = (value: boolean) => {
  toggle.value = value
}
watch(() => props.close, (value) => {
  toggleList(false)
})
const handleClickOutside = (event: MouseEvent) => {
  toggleList(false)
};
const selectItem = (index: number, value: string) => {
  selectedItem.value = index
  toggleList(false)
  model.value = value
  emit('update:model', value)
}
watch(() => model.value, (value) => {
  setSelected(value)
})
const setSelected = (value: string | undefined) => {
  if (value) {
    const index = props.data.findIndex((item) => item.iso === value)
    if (index > -1) {
      selectedItem.value = index
    }
  }
}
onMounted(() => {
  setSelected(model.value)
})
</script>

<style lang="scss" scoped>
  .list-ctn {
    &.white {
      background-color:  var(--button-primary-white-background-color, #FFFFFF);
      scrollbar-color: var(--button-primary-sun-background-color, #FFA300);
    }
    &.white::-webkit-scrollbar-thumb {
      -webkit-appearance: none;
      background: var(--button-primary-sun-background-color, #FFA300);
      border-radius: 0.5rem;
    }
    &.none {
      background-color:  transparent;
      scrollbar-color: black;
    }
    margin-top: 0.125rem;
    position: absolute;
    overflow-y: scroll;
    border-radius: 1rem;
    max-height: 12rem;
  }
</style>
